import { UserAccountType } from "@common/constants/UserAccountType";

export const RETAIL_USER_WALLETS = new Set([
	UserAccountType.SportBettingAccountShopOnline,
	UserAccountType.SportBettingAccountShop,
	UserAccountType.CashToDigitalAccount,
]);
